enum UsersStatic {
  /**
   * @member {string}
   * @method post
   * @version 2.0
   * @description create user
   */
  UserCreate = "/v2/users/create",

  /**
   * @member {string}
   * @method post
   * @version 2.0
   * @description list user
   */
  UsersList = "/v2/users",

  /**
   * @member {string}
   * @method get
   * @version 2.0
   * @description list user
   */
  CheckIdentification = "/v2/users/check-identification",

  /**
   * @member {string}
   * @method get
   * @version 2.0
   * @description list user
   */
  CheckEmail = "/v2/users/check-email",

  /**
   * @member {string}
   * @method post
   * @version 2.0
   * @description send OTP
   */
  SendOTP = "/v2/users/send-otp",

  /**
   * @member {string}
   * @method get
   * @version 2.0
   * @description get current user
   */
  GetCurrentUser = "/v2/user/",

  /**
   * @member {string}
   * @method post
   * @version 2.0
   * @description login as
   */
  LoginAs = "/v2/users/login-as",

  /**
   * @member {string}
   * @method get
   * @version 3.0
   * @description get agents plans list
   */
  UsersPlans = "/v3/admin/agent-plans"
}

const UsersDynamic = {
  /**
   * @member {string}
   * @method put
   * @version 2.0
   * @description create user
   */
  UserUpdate: (id: number) => `/v2/users/${id}?_method=PUT`,
  /**
   * @member {string}
   * @method put
   * @version 2.0
   * @description create user
   */
  UserDetail: (id: number) => `/v2/users/${id}`,

  /**
   * @member {string}
   * @method patch
   * @version 2.0
   * @description enable user
   */
  ActivateUser: (id: number) => `/v2/users/enable/${id}?_method=PUT`,
  /**
   * @member {string}
   * @method patch
   * @version 2.0
   * @description suspend user
   */
  SuspendUser: (id: number) => `/v2/users/suspend/${id}`,
  /**
   * @member {string}
   * @method put
   * @version 2.0
   * @description inactive user
   */
  InactiveUser: (id: number) => `/v2/users/disable/${id}?_method=PUT`,
  /**
   * @member {string}
   * @method post
   * @version 2.0
   * @description resend user
   */
  resendEmailUser: (id: number) => `/v2/users/${id}/resend-welcome-email`,
  /**
   * @member {string}
   * @method PUT
   * @version 1.0
   * @description last changes RealEstates request
   */
  historyChanges: (id: string | number) => `/v2/admin/realestates/${id}/changes`
};

export const UsersEndpoints = {
  ...UsersDynamic,
  ...UsersStatic
};

export type UsersEndpoints = typeof UsersEndpoints;
